import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { LocationModel } from "./location-data-model";

export class LocationGridModel extends LocationModel { }

export class LocationListingModel extends GridModel<LocationGridModel> { }
export class LocationGridPostParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}